import { z } from 'zod';
import { IdSchema, IsoDateTimeSchema, OrgIdSchema, UserIdSchema } from '../api/common.js';
/** What an audit event was recorded against. */
export const AuditSubjectTypeSchema = z.enum(['APPLICATION', 'ENGAGEMENT', 'CLOUD_CONNECTION']);
export const AuditActionSchema = z.enum([
    'APPLICATION_CREATED',
    'APPLICATION_UPDATED',
    'ENGAGEMENT_CREATED',
    'ENGAGEMENT_UPDATED',
    'SCOPE_DEFINED',
    'APPROVAL_RECORDED',
    'AGENT_RUN_REQUESTED',
    'SCAN_STARTED',
    'SCAN_FINISHED',
    /** The engagement moved stage other than by an approval: a scan started, or someone asked. */
    'STAGE_CHANGED',
    /** A finding's status was decided. The reason is on the TRIAGE# record, not here (§4). */
    'FINDING_TRIAGED',
    /** A report snapshot was generated and stored for the Report gate. */
    'REPORT_GENERATED',
    /** A cloud account key was stored. Never the key itself — only that it happened (§4). */
    'CLOUD_CONNECTION_CREATED',
    'CLOUD_CONNECTION_VERIFIED',
    'CLOUD_CONNECTION_REJECTED',
    'CLOUD_CONNECTION_ROTATED',
    'CLOUD_CONNECTION_REVOKED',
    /** A discovery of a connected account was requested. What it found is in its snapshot. */
    'CLOUD_DISCOVERY_REQUESTED',
    /** Someone decided a discovered application proposal is not an application (ADR 0008). */
    'APPLICATION_PROPOSAL_DISMISSED',
    /** Guardian opened a pull request with a proposed fix. The diff is the pull request's. */
    'REMEDIATION_PROPOSED',
    /** A proposed fix moved on: merged, deployed, closed, re-scanned, or failed. */
    'REMEDIATION_STATUS_CHANGED',
    /** A re-scan proved, or failed to prove, that a merged fix works. */
    'REMEDIATION_VERIFIED',
]);
/**
 * An append-only record of who changed what (§5). Written in the same transaction as the
 * change itself, so a state change can never exist without its audit event.
 *
 * `changed` lists field *names* only — never values, which could carry customer data (§4).
 */
export const AuditEventSchema = z.object({
    id: IdSchema,
    orgId: OrgIdSchema,
    subjectType: AuditSubjectTypeSchema,
    subjectId: IdSchema,
    action: AuditActionSchema,
    actorUserId: UserIdSchema,
    at: IsoDateTimeSchema,
    changed: z.array(z.string()).optional(),
});
export const ListAuditResponseSchema = z.object({ items: z.array(AuditEventSchema) });
//# sourceMappingURL=audit.js.map